var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLatch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 113,
    viewBox: "0 0 84 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 42C2 59.0914 12 85 42 110C72 85 82 59.0914 82 42C82 19.9086 64.0914 2 42 2C19.9086 2 2 19.9086 2 42ZM42 52C47.5228 52 52 47.5228 52 42C52 36.4772 47.5228 32 42 32C36.4772 32 32 36.4772 32 42C32 47.5228 36.4772 52 42 52Z",
    fill: "#E84B17",
    stroke: "#1A1C20",
    strokeWidth: 4
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLatch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/latch.6a1d16bdbce3f6872017d7efb91bf3c3.svg";